<div class="add-organization page">
  @if (!isLoading) {
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
    <div class="heading-wrapper">
      <h4>{{ 'pages.organization.titleAdd' | translate }}</h4>
      <div class="actions d-flex">
        <button class="primary add-btn" (click)="submit()">
          {{ 'pages.organization.submitAdd' | translate }}
        </button>
        <button class="secondary back-btn" (click)="back()">
          {{ 'pages.organization.back' | translate }}
        </button>
      </div>
    </div>
    <div class="section">
      <app-organization-general-info-form
        mode="add"
        [countries]="countries"
        (legalEntityCreated)="onLegalEntityCreated($event)" />
    </div>
  } @else {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="isLoading" />
    </div>
  }
</div>

<app-confirm-modal
  title="cancelOrgCreation"
  bodyText="cancelOrgCreationBody"
  confirmText="cancelOrgCreationConfirm"
  denyText="cancelOrgCreationDeny"
  [isOpen]="confirmModalOpen"
  (cancel)="confirmModalOpen = false"
  (confirm)="confirmBack()" />
